import { PRESUPUESTADOR_ADD_PAYMENT_METHOD } from './constants'

export function addPaymentMethod(paymentMethod) {
  return {
    type: PRESUPUESTADOR_ADD_PAYMENT_METHOD,
    data: {
        paymentMethod,
    },
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_ADD_PAYMENT_METHOD) {
    const newPaymentMethod = action.data.paymentMethod
    const newPaymentsMethods = [...state.payments_methods, newPaymentMethod]


    return {
      ...state,
      payments_methods: newPaymentsMethods,
    }
  } else {
    return state
  }
}
